export default __webpack_public_path__ + "static/media/icon-prescription.771be36f.svg";